function CareerServicesCurriculumRightCard({ Goal, list }) {
  return (
    <div className="col-12 topic-details card-wrapper-outer">
      <div className="d-flex justify-content-between align-items-center">
        
        <div className="sub-title d-flex align-items-end">
          <p>Goal:&nbsp;</p>
          <p>{Goal}</p>
        </div>
      </div>
      <div className="border-outline w-100 my-1 my-md-4"></div>
      
      <ul className="text-left custom-scroll mt-2 mt-md-0">
        {list?.map((item) => (
          <li>{item}</li>
        ))}
      </ul>
    </div>
  );
}
export default CareerServicesCurriculumRightCard;
